import { useState, useEffect } from 'react'
import { Progress } from '@/components/ui/progress'
import { WrenchScrewdriverIcon } from '@heroicons/react/24/outline'

const MESSAGES = [
  'Preparing CAD file...',
  'Analyzing CAD file structure...',
  'Analyzing CAD assembly tree...',
  'Processing remaining CAD features...',
]

export const CadVersionProgressBar = () => {
  const [progress, setProgress] = useState(30)
  const [progressMessageIndex, setProgressMessageIndex] = useState(0)

  const maxp = 90

  useEffect(() => {
    const iv = setInterval(() => {
      setProgress((prev) => {
        if (prev >= maxp) {
          clearInterval(iv)
          return prev
        }

        const velocity = 0.1
        const step = Math.max(0.5, (maxp - prev) * velocity)
        return Math.min(prev + step, maxp)
      })
      setProgressMessageIndex(
        Math.min(progressMessageIndex + 1, MESSAGES.length - 1),
      )
    }, 1500)

    return () => clearInterval(iv)
  }, [progressMessageIndex])

  return (
    <div className="flex flex-col space-y-4 w-full max-w-xl px-8 text-center items-center mt-10">
      <WrenchScrewdriverIcon className="h-8 w-8" />
      <div>{MESSAGES[progressMessageIndex]}</div>
      <Progress value={progress} />
    </div>
  )
}
